<main id="main-content" class="recover-box">
    <div class="container">
        <div class="row">
            <div class="col-md-6 recover">
                <div class="row recover-content">
                    <div class="col-12">
                        <h1 class="title-recovery" i18n>Recuperar contraseña</h1>
                    </div>
                    <div class="col-12 mb-3">
                        <div class="row">
                            <label for="usuario" class="form-label"><span i18n>Usuario</span>:</label>
                            <input type="text" class="form-control" id="usuario" [(ngModel)]="usuario">
                        </div>
                    </div>
                    <div class="col-12 mb-3">
                        <div class="row">
                            <label for="password" class="form-label"><span i18n>Nueva contraseña</span>:</label>
                            <input type="password" class="form-control mb-1" id="password" [(ngModel)]="password">
                            <small class="text-white" i18n>La longitud de la contraseña debe estar comprendida entre 8 y 30 caracteres, y debe incluir números, símbolos, mayúsculas y minúsculas</small>
                        </div>
                    </div>
                    <div class="col-12 mb-3">
                        <div class="row">
                            <label for="email" class="form-label"><span i18n>Email</span>:</label>
                            <input type="text" class="form-control" id="email" [(ngModel)]="email">
                        </div>
                    </div>
                    <div class="col-12" *ngIf="!showCode">
                        <div class="row text-center">
                            <button class="btn btn-secondary" (click)="recoverPass()" i18n>Recuperar</button>
                        </div>
                    </div>
                    <div class="col-12 mb-3" *ngIf="showCode">
                        <div class="row">
                            <label for="code" class="form-label"><span i18n>Codigo</span>:</label>
                            <input type="text" class="form-control" id="code" [(ngModel)]="code">
                        </div>
                    </div>
                    <div class="col-12" *ngIf="showCode">
                        <div class="row text-center">
                            <button class="btn btn-secondary" (click)="setPass()" i18n>Aceptar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>